import { OrganizationStatus } from '@repo/shared/types';
import { Badge } from '@repo/ui/badge';
import { Label } from '@repo/ui/label';
import { Switch } from '@repo/ui/switch';
import { trpc } from '@/providers/trpc';
import type { RouterOutputs } from '@/providers/trpc-client';

interface OrganizationsTableActionsProps {
  organization: RouterOutputs['admin']['listOrganizations']['data'][number];
}

export function OrganizationsTableActions({ organization }: OrganizationsTableActionsProps) {
  const activateOrganization = trpc.admin.activateOrganization.useMutation();
  const deactivateOrganization = trpc.admin.deactivateOrganization.useMutation();

  const organizationStatus = organization.status;
  const isOrganizationSuspended = [
    OrganizationStatus.DELETED,
    OrganizationStatus.SUSPENDED,
    OrganizationStatus.UNVERIFIED,
  ];
  const disabled =
    activateOrganization.isPending ||
    deactivateOrganization.isPending ||
    isOrganizationSuspended.some((s) => s === organizationStatus);

  return (
    <div className="flex items-center gap-2">
      <Label htmlFor="organization-status">
        <Badge variant={organizationStatus === OrganizationStatus.ACTIVE ? 'default' : 'secondary'}>
          {organizationStatus}
        </Badge>
      </Label>
      <Switch
        checked={organizationStatus === OrganizationStatus.ACTIVE}
        disabled={disabled}
        id="organization-status"
        onCheckedChange={(checked) => {
          checked
            ? activateOrganization.mutate({ organizationId: organization.id })
            : deactivateOrganization.mutate({ organizationId: organization.id });
        }}
      />
    </div>
  );
}
